//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
import countryTranslations from "./countries.js";
import interfaceTranslations from "./interface.js";

export { countryTranslations, interfaceTranslations };
export default { ...countryTranslations, ...interfaceTranslations };
